import { Form, Input, Row, Col, Switch, Select, DatePicker, Tooltip } from 'antd';
import { useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from "../../universal/getList";
import moment from 'moment';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 },  
};

const WebProductOrderEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };
    const [transactionModeData, setTransactionModeDat] = useState<any>();
    const [payTypeData, setPayTypeData] = useState<any>();
    const [paymentProcessData, setPaymentProcessData] = useState<any>();
    //手动支付成功数据
    const [manualPaymentSucceededData, SetManualPaymentSucceededData] = useState<any>();
    const [formDisabledData, setFormDisabledData] = useState<any>(true)
    /** 后端数据defaultService */
    let defaultService: any = '';

    const handleManualPaymentSucceeded = (data: any) => {
        const { value } = data;
        if (value === true) {
            setFormDisabledData(false);
        }
        else {
            setFormDisabledData(true);
        }
    }

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
        }
        const fetchData = async () => {
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'transactionMode',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setTransactionModeDat(res.data)
                    }
                });
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'payType',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setPayTypeData(res.data)
                    }
                });
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'paymentProcess',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setPaymentProcessData(res.data)
                    }
                });
        };
        fetchData();
        SetManualPaymentSucceededData([{
            id: true,
            name: '执行'
        }])
    }, []);

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'webOrderPay',
        dateColumnName: ['payDate', 'lastPaymentTime'],
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '支付单'}
                open={true}
                okText={'ok'}
                cancelText="取消"
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={1000}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyPress={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={7}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="金额"
                                name="paymentAmount">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="最后支付"
                                name="lastPaymentTime"
                                initialValue={moment(new Date())}>
                                <DatePicker
                                    disabled={false}
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="方式"
                                name="transactionModeId">
                                <Select
                                    disabled={formDisabledData}
                                    showSearch
                                    placeholder="方式"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(transactionModeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="类型"
                                name="payTypeId">
                                <Select
                                    disabled={true}
                                    showSearch
                                    placeholder="类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(payTypeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="支付id"
                                name="payId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Tooltip placement="topLeft" title={'内部交易单号'}>
                                <Form.Item
                                    label="单号"
                                    name="tradeNo">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Tooltip>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="交易号"
                                name="transactionNo">
                                <Input disabled={formDisabledData} />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="支付时间"
                                name="payDate"
                                initialValue={moment(new Date())}>
                                <DatePicker
                                    disabled={formDisabledData}
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="wxOpenId"
                                name="wxOpenId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="支付进程"
                                name="paymentProcess">
                                <Select
                                    disabled={true}
                                    showSearch
                                    placeholder="支付进程"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(paymentProcessData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="支付状态"
                                name="isPay"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch
                                    disabled={formDisabledData}
                                    checked={true}
                                    checkedChildren="已支付"
                                    unCheckedChildren="未支付" />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch
                                    disabled={false}
                                    checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="订单id"
                                name="productOrderId"
                                initialValue={data.productOrderId}>
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Tooltip placement="topLeft" title={'手动支付成功，小心使用'}>
                                <Form.Item
                                    label="手动支付"
                                    name="manualPaymentSucceeded">
                                    <Select
                                        showSearch
                                        placeholder="手动支付成功"
                                        optionFilterProp="children"
                                        onSelect={(_e: any, data: any) => handleManualPaymentSucceeded(data)}
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(manualPaymentSucceededData)}
                                    </Select>
                                </Form.Item>
                            </Tooltip>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="识别码"
                                name="identificationCode">
                                <Input disabled={formDisabledData} />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default WebProductOrderEdit;